export default __webpack_public_path__ + "static/media/return-box.0cb1d3dc.png";